// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fragment-drawer-view > .wui-drawer > .wui-drawer-close {
  z-index: 1;
}
.fragment-drawer-view > .wui-drawer > .wui-drawer-body {
  min-height: 100%;
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/dialog/index.less"],"names":[],"mappings":"AAEI;EACE,UAAA;AADN;AAGI;EACE,gBAAA;EACA,UAAA;AADN","sourcesContent":[".fragment-drawer-view {\n  & > .wui-drawer {\n    & > .wui-drawer-close {\n      z-index: 1;\n    }\n    & > .wui-drawer-body {\n      min-height: 100%;\n      padding: 0;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
